import { PointConfig } from '@src/types/PointConfig';
import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';

export interface UseGetPointConfigsFilteredBody {
  filter: {
    deviceType?: {
      $in: string[];
    };
    // engineeringId?: string;
    // parentControllerId?: string;
  };
}
interface UseGetPointConfigsProps {
  body: UseGetPointConfigsFilteredBody;
  options?: { enabled?: boolean; queryKeys?: string[] };
}

export default ({
  body,
  options,
}: UseGetPointConfigsProps): ReturnType<typeof useApiQuery<PointConfig[]>> =>
  useApiQuery<PointConfig[]>({
    queryKey: [
      QueryKeys['pointConfigsFiltered'],
      [...(options?.queryKeys || [])].join('-'),
    ],
    apiPath: '/point-configs/search',
    method: 'POST',
    useV2API: true,
    body,
    enabled: typeof options?.enabled === 'boolean' ? options.enabled : true,
  });
